class drawerDetailCtrl {
    constructor($scope, httpRequest, globalFn, logger, sweetalert, $location, $state, $stateParams) {
        $scope.dictData = {}
        $scope.statusList0 = [
            {
                id: '',
                text: '全部',
            },
            {
                id: 0,
                text: '未启用',
            },
            {
                id: 1,
                text: '启用',
            },
        ]
        httpRequest.get_dictByTypeArr('["certificate_type","drawer_active_status","identity_type","drawer_channel_type"]').then((res) => {
            $scope.dictData = res.data.value
        })

        function queryList() {
            httpRequest.post_ovatTax4Drawerget({ drawerId: $stateParams.drawerId }).then((res) => {
                $scope.formObj = res.data.value
            })
            httpRequest.post_ovatTax4DrawerqueryManagementScope($stateParams.drawerId).then((res) => {
                $scope.formData = res.data.value
            })
        }
        queryList()

        $scope.cancel = function () {
            $state.go('outputManage.fullElectricInvoice.drawer.list')
        }
    }
}

drawerDetailCtrl.$inject = ['$scope', 'httpRequest', 'globalFn', 'logger', 'sweetalert', '$location', '$state', '$stateParams']
export default drawerDetailCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/drawer/detail.js